<template>
    <div class="container">
        <SectionHeader
            title="Stay Connected"
            description="Follow me on social media to get latest updates"
        />
        <div class="row">
            <div
                class="col item mb-3 text-center email"
                v-if="settings.email_primary && false"
            >
                <a
                    :href="settings.email_primary"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div class="icon">
                        <i class="fa fa-envelope"></i>
                    </div>
                    <div class="name">Email</div>
                    <div class="username">
                        {{ settings.email_primary }}
                    </div>
                </a>
            </div>
            <div
                class="col item mb-3 text-center whatsapp"
                v-if="settings.whatsapp"
            >
                <a
                    :href="settings.whatsapp"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div class="icon">
                        <i class="fab fa-whatsapp"></i>
                    </div>
                    <div class="name">whatsapp</div>
                    <div class="username">
                        @{{ getUserName(settings.whatsapp) }}
                    </div>
                </a>
            </div>
            <div
                class="col item mb-3 text-center facebook"
                v-if="settings.facebook"
            >
                <a
                    :href="settings.facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div class="icon">
                        <i class="fab fa-facebook"></i>
                    </div>
                    <div class="name">Facebook</div>
                    <div class="username">
                        @{{ getUserName(settings.facebook) }}
                    </div>
                </a>
            </div>
            <div
                class="col item mb-3 text-center instagram"
                v-if="settings.instagram"
            >
                <a
                    :href="settings.instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div class="icon">
                        <i class="fab fa-instagram"></i>
                    </div>
                    <div class="name">Instagram</div>
                    <div class="username">
                        @{{ getUserName(settings.instagram) }}
                    </div>
                </a>
            </div>
            <div
                class="col item mb-3 text-center twitter"
                v-if="settings.twitter"
            >
                <a
                    :href="settings.twitter"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div class="icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                        >
                            <path
                                fill="currentColor"
                                d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                            />
                        </svg>
                    </div>
                    <div class="name">Twitter</div>
                    <div class="username">
                        @{{ getUserName(settings.twitter) }}
                    </div>
                </a>
            </div>
            <div
                class="col item mb-3 text-center linkedin"
                v-if="settings.linkedin"
            >
                <a
                    :href="settings.linkedin"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div class="icon">
                        <i class="fab fa-linkedin"></i>
                    </div>
                    <div class="name">LinkedIn</div>
                    <div class="username">
                        @{{ getUserName(settings.linkedin) }}
                    </div>
                </a>
            </div>
            <div
                class="col item mb-3 text-center youtube"
                v-if="settings.youtube"
            >
                <a
                    :href="settings.youtube"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div class="icon">
                        <i class="fab fa-youtube"></i>
                    </div>
                    <div class="name">YouTube</div>
                    <div class="username">
                        @{{ getUserName(settings.youtube) }}
                    </div>
                </a>
            </div>
            <div
                class="col item mb-3 text-center telegram"
                v-if="settings.telegram"
            >
                <a
                    :href="settings.telegram"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div class="icon">
                        <i class="fab fa-telegram"></i>
                    </div>
                    <div class="name">Telegram</div>
                    <div class="username">
                        @{{ getUserName(settings.telegram) }}
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        settings() {
            return this.$page.props.config.settings;
        },
    },
    methods: {
        getUserName(url) {
            // get final part of url
            return url.split("/").pop();
        },
    },
};
</script>
<style lang="scss" scoped>
.item {
    --color: 37, 211, 102;
    --color-contrast: #fff;

    &.email {
        --color: 255, 0, 0;
        --color-contrast: #fff;
    }

    &.whatsapp {
        --color: 18, 140, 126;
        --color-contrast: #fff;
    }

    &.facebook {
        --color: 59, 89, 152;
        --color-contrast: #fff;
    }

    &.instagram {
        --color: 255, 64, 129;
        --color-contrast: #fff;
    }

    &.twitter {
        --color: 0, 0, 0;
        --color-contrast: #fff;
    }

    &.linkedin {
        --color: 0, 119, 181;
        --color-contrast: #fff;
    }

    &.youtube {
        --color: 255, 0, 0;
        --color-contrast: #fff;
    }

    &.telegram {
        --color: 30, 136, 229;
        --color-contrast: #fff;
    }

    .icon {
        width: 4.4rem;
        height: 4.2rem;
        background-color: rgba(var(--color), 0.1);
        border-radius: var(--border-radius);
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        transition: var(--transition);
        i {
            font-size: 2rem;
            color: rgba(var(--color));
            transition: var(--transition);
        }
        svg {
            transition: var(--transition);
            height: 2rem;
            width: 2rem;

            path {
                fill: rgba(var(--color));
            }
        }
    }
    a {
        display: block;
        padding: 0 0.1rem;

        &:hover {
            .icon {
                background-color: rgba(var(--color));
                i {
                    color: var(--color-contrast);
                }
                svg path {
                    fill: var(--color-contrast);
                }
            }
        }
    }
    .name {
        margin-top: 1rem;
        font-size: 1rem;
        font-weight: bold;
        color: var(--dark);
    }
    .username {
        font-size: 0.9rem;
        color: var(--dark);
        opacity: 0.7;
    }
}
</style>
